import React, { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";
import Breadcrumb from "../../App/Components/Navigation/Breadcrumbs/Breadcrumbs";
import { Button, Dialog, Grid } from "@mui/material";
import {
  getFeaturedGroups,
  updateFeaturedGroupOrder,
} from "./FeaturedGroupsService";
import FeaturedGroupsTableCell from "./Components/FeaturedGroupsTableCell";
import AddFeaturedGroupModal from "./Components/AddFeaturedGroupModal";
import Signifier from "../../App/Components/Signifier/Signifier";
import { basicSort } from "../../App/Helpers/BasicSort";
import { useSelector } from "react-redux";
import { selectCareersClientValue } from "../../App/State/Slices/SelectedCareersClientSlice";
import DraggableTable from "../../App/Components/Table/DraggableTable";
import { callAPI } from "../../App/Helpers/callApi";

function FeaturedGroups() {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "50%",
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },
    autocomplete: {
      width: "35%",
      paddingBottom: "20px",
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },
    hint: {
      position: "absolute",
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      marginTop: "auto",
      marginBottom: "auto",
      marginLeft: "auto",
      marginRight: "auto",
      width: "300px",
      height: "300px",
      fontSize: "32px",
      textAlign: "center",
      color: "rgba(0,0,0,.6)",
    },
  }));

  const classes = useStyles();

  const selectCareersClient = useSelector(selectCareersClientValue);
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openAddModal, setOpenAddModal] = useState(false);
  const [showSignifier, setShowSignifier] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [processing, setProcessing] = useState(false);

  const columns = [
    { label: "Name", propName: "name" },
    { label: "# Of Jobs", propName: "featureAdsLength" },
    { label: "Edit", propName: "" },
    { label: "Delete", propName: "" },
    { label: "", propName: "" },
  ];

  function updateOrder() {
    var update = [...tableData];

    update.sort((a, b) => {
      const order = basicSort(a?.name.toUpperCase(), b?.name.toUpperCase());
      if (order !== 0) return order;
      return a[1] - b[1];
    });

    setTableData(update);

    update.forEach((group, index) => (group.order = index + 1));
    callAPI(
      updateFeaturedGroupOrder(selectCareersClient.id, update),
      "Order Updated",
      setShowSignifier,
      setResponseMessage,
      setShowError,
      setProcessing
    );
  }

  useEffect(() => {
    // update only when the user makes a change (not when loading from db)
    if (tableData.length > 0 && !loading) {
      var update = [...tableData];
      update.forEach((group, index) => (group.order = index + 1));
      updateFeaturedGroupOrder(selectCareersClient.id, update);
    }
  }, [tableData]);

  useEffect(() => {
    // retrieve and sort page data any time the selected client changes
    if (selectCareersClient !== null) {
      setLoading(true);
      getFeaturedGroups(selectCareersClient.id).then((response) => {
        response.sort((a, b) => {
          const order = basicSort(a.order, b.order);
          if (order !== 0) return order;
          return a[1] - b[1];
        });
        response.forEach(
          (row) => (row.featureAdsLength = row.featureAds.length)
        );
        response.forEach((row) =>
          row.featureAds.sort((a, b) => {
            const order = basicSort(a.order, b.order);
            if (order !== 0) return order;
            return a[1] - b[1];
          })
        );
        setTableData(response);
        setLoading(false);
      });
    }
  }, [selectCareersClient]);

  return (
    <>
      <Signifier
        showSignifier={showSignifier}
        setShowSignifier={setShowSignifier}
        message={responseMessage}
        error={showError}
      />
      <div className="page-container">
        <Breadcrumb />
        <h1 className="page-title">
          {selectCareersClient.shortName} Featured Groups
        </h1>
        <div className={classes.root}>
          {selectCareersClient === null ? (
            <div className={classes.hint}>
              <span>Select a client</span>
            </div>
          ) : (
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12}>
                <Button
                  style={{
                    marginTop: "20px",
                    marginBottom: "20px",
                    marginRight: "20px",
                  }}
                  type="submit"
                  variant="contained"
                  color="primary"
                  onClick={() => updateOrder()}
                >
                  Order Alphabetically
                </Button>
                <Button
                  style={{ marginTop: "20px", marginBottom: "20px" }}
                  type="submit"
                  variant="contained"
                  color="primary"
                  onClick={() => setOpenAddModal(!openAddModal)}
                >
                  Add Group
                </Button>
              </Grid>
              <DraggableTable
                columns={columns}
                tableData={tableData}
                setTableData={setTableData}
                rowComponent={FeaturedGroupsTableCell}
                loading={loading}
              />
            </Grid>
          )}
        </div>
      </div>
      <Dialog open={openAddModal} onClose={() => setOpenAddModal(false)}>
        <AddFeaturedGroupModal
          openModal={setOpenAddModal}
          client={selectCareersClient}
          setShowSignifier={setShowSignifier}
          setResponseMessage={setResponseMessage}
          setShowError={setShowError}
          setTableData={setTableData}
        />
      </Dialog>
    </>
  );
}

export default FeaturedGroups;
